import { PersistenceEvent } from '../persistenceEvents/persistenceEvent';
import { SyncEventType } from '../../enums/syncEventType';
import { CommActionItem } from '../../../interfaces/comm-action-item';


export class EventActionItemEdited implements PersistenceEvent {
  public readonly type = SyncEventType.AI_ISSUE_SUGGESTION_EDITED;
  public actionItemId: number | null;
  public update: Partial<CommActionItem>;

  constructor(actionItemId: number | null, update: Partial<CommActionItem>) {
    this.actionItemId = actionItemId;
    this.update = update;
  }

  getPayload(): object {
    return {
      id: this.actionItemId,
      update: this.update,
    };
  }
}
